if (!customElements.get("sun365-paypal-message")) {
  customElements.define("sun365-paypal-message", class extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector("[data-pp-message]");
      this.price = this.closest(".product-price-tax")?.querySelector('[id^="Price-"]');
      if (!this.message || !this.price) return;
      this.observer = new MutationObserver(() => this.syncAmount());
      this.observer.observe(this.price, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-sun365-paypal-price", "data-available"] });
      this.syncAmount();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
    syncAmount() {
      const source = this.price.querySelector("[data-sun365-paypal-price]");
      const amount = Number(source?.dataset.sun365PaypalPrice);
      const eligible = source?.dataset.available === "true" && Number.isFinite(amount) && amount > 0;
      this.hidden = !eligible;
      if (!eligible) return;
      const value = (amount / 100).toFixed(2);
      if (this.message.getAttribute("data-pp-amount") !== value) {
        this.message.setAttribute("data-pp-amount", value);
      }
    }
  });
}
